import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ForbiddenScreen.module.scss';
import { Container } from 'react-bootstrap';

const ForbiddenScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Container>
                <h1>404 - {t('messages.page_forbidden')}</h1>
        </Container>
    );
};

export default ForbiddenScreen;
